import { IMeta } from '@bees-web/core/types'
import {
  rateMyServiceChange,
  rateMyServiceResetState,
} from '../../actions/ratings'
import {
  trackServiceRatingModalViewed,
  trackServiceRatingSkipped,
  trackServiceRatingSuccessInteracted,
} from '../../actions/ratings/segment/RateMyService'
import {
  defineEntryMethodAndScreen,
  getAnswerTypes,
} from '../../utils/ratingsUtils'

let vendorId: string | undefined
let ticketId: string | undefined

export const rateMyService = (dispatch, interactiveState, globalActions) => {
  const rateMyServiceState = interactiveState.state.ratingService.rateMyService
  const { user, authentication } = interactiveState.globals

  return {
    attributes: {
      open: rateMyServiceState.isShowing,
      onDeferredLoad: (meta: IMeta) => {
        const queryParam = meta?.request?.body?.useCaseType?.toLowerCase()

        if (meta.data) {
          if (meta.data.ratingType?.includes('MULTIPLE_QUESTION')) {
            dispatch(rateMyServiceChange({ isVisibleQuestions: true }))
          }
          dispatch(
            rateMyServiceChange({
              rmsResponse: meta.data,
            })
          )
          const getRequiredQuestions = meta.data.questions
            ?.filter((question) => question.isAnswerRequired)
            ?.map((question) => question.id)
          dispatch(
            rateMyServiceChange({
              requiredQuestions: getRequiredQuestions,
            })
          )
        }

        const modalTitle =
          rateMyServiceState.modalStatus === 'submitted'
            ? meta?.headerTranslation?.feedbackSent
            : meta?.headerTranslation?.rateSupportService

        dispatch(
          rateMyServiceChange({
            isShowing:
              queryParam === 'ticket' &&
              meta?.ticket?.content?.length > 0 &&
              meta.orderNumberRMD === 'undefined' &&
              meta.showInHome,
            modalTitle,
            submittedStateTitle: meta?.headerTranslation?.feedbackSent,
            defaultModalTitle: meta?.headerTranslation?.rateSupportService,
          })
        )
        vendorId = meta?.ticket?.content[0]?.metadata?.vendorId
        ticketId = meta?.ticket?.content[0]?.useCaseId
      },
      onClose: () => {
        dispatch(rateMyServiceResetState)

        const { entry_method, screen_name } = defineEntryMethodAndScreen()
        if (rateMyServiceState.modalStatus === 'submitted') {
          dispatch(
            trackServiceRatingSuccessInteracted({
              app_instance: user?.country,
              poc_id: authentication?.selectedAccount?.accountId,
              screen_name: screen_name,
              rating_type: rateMyServiceState.rmsResponse.ratingType,
              answer_type: getAnswerTypes(
                rateMyServiceState?.rmsResponse?.questions
              ),
              number_of_questions:
                rateMyServiceState?.rmsResponse?.questions?.length,
              rating_sucess_action: 'X button',
              entry_method: entry_method,
            })
          )
        }
        if (rateMyServiceState.modalStatus === 'initial') {
          dispatch(
            trackServiceRatingSkipped({
              app_instance: user?.country,
              entry_method: entry_method,
              poc_id: authentication?.selectedAccount?.accountId,
              screen_name: screen_name,
              ticket_id: ticketId,
              vendorId: vendorId,
              rating_type: rateMyServiceState?.rmsResponse?.ratingType,
              answer_type: getAnswerTypes(
                rateMyServiceState?.rmsResponse?.questions
              ),
              number_of_questions:
                rateMyServiceState?.rmsResponse?.questions?.length,
            })
          )
        }
      },
      onLoad: async () => {
        const { entry_method, screen_name } = defineEntryMethodAndScreen()
        dispatch(
          trackServiceRatingModalViewed({
            poc_id: authentication?.selectedAccount?.accountId,
            screen_name: screen_name,
            app_instance: user.country,
            vendorId,
            ticket_id: ticketId,
            rating_type: rateMyServiceState?.rmsResponse?.ratingType,
            answer_type: getAnswerTypes(
              rateMyServiceState?.rmsResponse?.questions
            ),
            number_of_questions:
              rateMyServiceState?.rmsResponse?.questions?.length,
            entry_method: entry_method,
          })
        )
      },
      style: {
        minWidth:
          rateMyServiceState.modalStatus === 'submitted' ? '448px' : '50%',
        maxHeight:
          rateMyServiceState.modalStatus === 'submitted' ? '464px' : '',
        height: window.innerHeight > 862 ? '43%' : 'auto',
        position: 'absolute',
        overflow: 'scroll',
      },
      header:
        rateMyServiceState.modalStatus === 'submitted'
          ? rateMyServiceState?.submittedStateTitle
          : rateMyServiceState?.defaultModalTitle,
    },
  }
}
